import React from 'react';
import { PageHeader } from '@shared/ui/pageHeader';
import { Tabs } from '@shared/ui/tabs';
import { All } from './tabs/All';
import { Manual } from './tabs/Manual';
import { Automated } from './tabs/Automated';
import { Mobile } from './tabs/Mobile';
import { useMeterRunCounts } from '../hook';
import { getRemoteUtilityId } from '@shared/utils/getUtilityId';

export const Landing: React.FC = () => {
  const utilityId = getRemoteUtilityId();
  const { data: counts } = useMeterRunCounts(utilityId);

  const tabComponents = {
    all: {
      label: 'All',
      shortLabel: 'all',
      component: <All />,
      count: counts?.all,
    },
    manual: {
      label: 'Manual',
      shortLabel: 'manual',
      component: <Manual />,
      count: counts?.manual,
    },
    automated: {
      label: 'Automated',
      shortLabel: 'automated',
      component: <Automated />,
      count: counts?.automated,
    },
    mobile: {
      label: 'Mobile',
      shortLabel: 'mobile',
      component: <Mobile />,
      count: counts?.mobile,
    },
  };

  const urlMapping = {
    all: 'all',
    manual: 'manual',
    automated: 'automated',
    mobile: 'mobile',
  };

  return (
    <div className="w-full space-y-6">
      <PageHeader
        title="Reads"
        description="Cycle run records across all read methods and routes."
      />

      <div className="w-full mt-6">
        <Tabs
          defaultValue="all"
          urlMapping={urlMapping}
          tabComponents={tabComponents}
          tabsListClassName="grid grid-cols-4"

        />
      </div>
    </div>
  );
};
export default Landing;
